    import Overlay from './Overlay';
    import gsap from "gsap";
    import MatchingAnswer from './MatchingAnswer';

    let gameScale;
    let sounds;
    let xmlLoader;
    let padding;
    let numPages;
    let thisPage;
    let domCounter;
    let thisX;
    let thisY;
    let thisWidth;
    let guide;
    let _this
    let imgBoundX;
    let imgBoundY;
    let imgBoundWidth;
    let imgBoundHeight;
    const quizLength = 10;
    let questionsArray;
    let thisQuestion;


    let answersArray;
    let score;
    let utils;
    let path = '././assets/images/';


    //Any assets not loaded in preloader may need to be loaded here first
    const assetArray = [{
        id: 'pou',
        path: path + 'pou.svg'
    }, {
        id: 'shell',
        path: path + 'shell.svg'
    }, {
        id: 'photo',
        path: path + 'photo.svg'
    }, {
        id: 'kete',
        path: path + 'kete.svg'
    }, {
        id: 'aoraki',
        path: path + 'aoraki.svg'
    }, {
        id: 'matchCouch',
        path: path + 'match-couch.svg'
    }, {
        id: 'matchCurtains',
        path: path + 'match-curtains.svg'
    }, {
        id: 'matchBooks',
        path: path + 'match-books.svg'
    }, {
        id: 'matchCabinet',
        path: path + 'match-cabinet.svg'
    }, {
        id: 'matchCarvingSkyFather',
        path: path + 'match-carvingskyfather.svg'
    }, {
        id: 'matchCarvingEarthMother',
        path: path + 'match-carvingearthmother.svg'
    }, {
        id: 'matchCentralRidgePole',
        path: path + 'match-centralridgepole.svg'
    }, {
        id: 'matchCushion',
        path: path + 'match-cushion.svg'
    }, {
        id: 'matchFishhook',
        path: path + 'match-fishhook.svg'
    }, {
        id: 'matchFloormat',
        path: path + 'match-floormat.svg'
    }, {
        id: 'matchGreenstone',
        path: path + 'match-greenstone.svg'
    }, {
        id: 'matchGumboots',
        path: path + 'match-gumboots.svg'
    }, {
        id: 'matchLamp',
        path: path + 'match-lamp.svg'
    }, {
        id: 'matchLowSeat',
        path: path + 'match-lowseat.svg'
    }, {
        id: 'matchPhoto',
        path: path + 'match-photo.svg'
    }, {
        id: 'matchPoi',
        path: path + 'match-poi.svg'
    }, {
        id: 'matchRadio',
        path: path + 'match-radio.svg'
    }, {
        id: 'matchShell',
        path: path + 'match-shell.svg'
    }, {
        id: 'matchSlippers',
        path: path + 'match-slippers.svg'
    }, {
        id: 'matchWindow',
        path: path + 'match-window.svg'
    }, {
        id: 'matchWoven',
        path: path + 'match-woven.svg'
    }, {
        id: 'check',
        path: path + 'check.svg'
    }, {
        id: 'cross',
        path: path + 'x.svg'
    }]

    export default class Matching extends Overlay {
        constructor() {
            super('matching');
        }

        preload() {
            _this = this;
            let preload = this.scene.get('preloader');
            // @ts-ignore
            preload.loadIt(assetArray, this.setup, this);

        }

        create() {
            utils = this.scene.get('utils');
        }

        setupParent() {
            super.create();

        }
        setup() {
            thisQuestion = 0;
            score = 0;
            questionsArray = [];
            answersArray = [];
            gameScale = _this.registry.get('scaleIt');
            thisX = 430 * gameScale;
            thisY = 165 * gameScale;
            thisWidth = 285 * gameScale;

            //imaginary rectangle is centred
            imgBoundX = 245 * gameScale;
            imgBoundY = 339 * gameScale;
            imgBoundWidth = 368 * gameScale;
            imgBoundHeight = 397 * gameScale;
            thisPage = 1;
            padding = _this.registry.get('padding') / 2;
            sounds = _this.scene.get('sounds');
            guide = _this.scene.get('guide');

            _this.setupParent();
        }
        parseXML() {
            xmlLoader = _this.scene.get('xmlLoader');
            super.parseXML();
        }

        active() {
            //get need variables from parent class
            super.shareVariables();
            this.findQuestions();

            this.createCounter();
            super.active();
        }

        //called once per quiz
        findQuestions() {
            xmlLoader.setSection('questions');
            //All potential questions
            questionsArray = [];
            let speeches = xmlLoader.getTag('speech', xmlLoader.getSection());

            //create an array of numbers
            let allNumbersArray = [];
            allNumbersArray = Phaser.Utils.Array.NumberArray(0, speeches.length - 1);
            Phaser.Utils.Array.Shuffle(allNumbersArray);
            //mix up the numbers randomly
            //pick the first x number to create this unique quiz
            for (let index = 0; index < quizLength; index++) {
                questionsArray.push(allNumbersArray[index]);
            }
        }

        updateQuestion() {
            this.scene.get('sounds').playPop();
            //Check if that was the last question
            if (thisQuestion == questionsArray.length) {
                this.finishedQuiz(score);
                return;
            }

            //deactive answers
            Phaser.Utils.Array.Each(answersArray, (obj) => {
                obj.destroyIt();
            }, this)

            this.updatePage();
        }
        setupAnswers() {
            answersArray = [];

            //Randomly find answers for this question
            let speeches = xmlLoader.getTag('speech', xmlLoader.getSection());

            let ran;
            let numArray = [];
            let isRepeat = false;

            //pick the first x number to create this unique quiz
            for (let index = 0; index < 4; index++) {
                //Pick a random number as large as there are speech tags
                ran = utils.randomNumber(speeches.length - 1);
                //track repeated numbers
                isRepeat = false;
                //Check if this value is the same as the question
                if (ran == questionsArray[thisQuestion]) {
                    index--;
                    isRepeat = true;
                    continue;
                }

                //Check for repeat
                Phaser.Utils.Array.Each(numArray, (num) => {
                    if (num == ran) {
                        isRepeat = true;
                        index--;
                    }
                }, this)

                if (!isRepeat) numArray[index] = ran;
            }

            this.createAnswers(numArray);

        }

        createAnswers(arr) {

            let a;
            let text;
            let correct;
            let speeches = xmlLoader.getTag('speech', xmlLoader.getSection());


            //Create answer objects based on the array passed in
            for (let index = 0; index < arr.length + 1; index++) {
                text = xmlLoader.getMaori(speeches[arr[index]]);
                correct = 'false';

                //The last go round add the correct answer
                if (index == arr.length) {
                    text = xmlLoader.getMaori(speeches[questionsArray[thisQuestion]]);
                    correct = 'true';
                }

                //create the answer object
                a = new MatchingAnswer({
                    scene: this,
                    text: text,
                    correct: correct
                });
                answersArray.push(a);
            }


            this.displayAnswers();



        }

        displayAnswers() {
            let answerX = this.domText.x;
            let answerY = this.domText.y + this.domText.height + padding * 3;

            let btn;
            //Shuffle the answer objects around
            Phaser.Utils.Array.Shuffle(answersArray);
            for (let index = 0; index < answersArray.length; index++) {
                btn = answersArray[index].getButton();
                btn.x = answerX;
                btn.y = answerY;

                answerY += btn.height + padding * 2;

                btn.visible = true;
            }

        }

        answerGiven(val) {
            //deactive answers
            Phaser.Utils.Array.Each(answersArray, (obj) => {
                let btn = obj.getButton();
                btn.disableInteractive();
            }, this)


            //increase question number

            if (val == 'true') this.incScore();
            //Wait before showing next question                
            this.time.delayedCall(1500, this.updateQuestion, this, this);

            if (thisQuestion == 0) {
                this.closeGuide();
            }
            thisQuestion++;

        }

        //called from the answer object if the answer is correct
        incScore() {
            score++;
        }

        finishedQuiz(score) {
            xmlLoader.setSection('messages');
            let per = score / quizLength;
            if (per > 0.55) {
                xmlLoader.setSpeech('wellDone');
            } else {
                xmlLoader.setSpeech('goodTry');
            }
            let txt = "<span class='speechExtra'><span class='bigger'>" + score + "/" + quizLength + "</span><br />" + xmlLoader.getLanguage() + "</span>";
            xmlLoader.setSpeech('tryAgain');
            txt = txt + "<br /><br />" + xmlLoader.getLanguage();

            guide.speechBubble({
                text: txt,
                callback: this.resetQuiz,
                context: this
            });
        }

        resetQuiz() {

            guide.animateBubbleOut();
            //xmlLoader.setSection('questions');
            thisQuestion = 0;
            score = 0;
            this.findQuestions();
            this.updateQuestion();
        }

        updateTextPosition() {
            super.updateTextPosition({
                x: thisX,
                y: thisY,
                width: thisWidth,
                class: 'bigger'
            });

            let text = xmlLoader.getEnglish();
            this.domText.node.innerHTML = text;
            this.domText.x = imgBoundX + imgBoundWidth / 2 + padding;
            this.domText.y = 153 * gameScale;
            let textStyle = this.domText.node.style;
            textStyle.fontSize = 28 * gameScale + 'px';
            this.domText.updateSize();

            this.domTitle.y = 96 * gameScale;
            this.domTitle.x = 0;

            textStyle = this.domTitle.node.style;
            textStyle.width = this.game.canvas.width + 'px';
            textStyle.fontSize = 28 * gameScale + 'px';

            textStyle.textAlign = 'center';
            this.domTitle.updateSize();

        }
        updatePage() {
            //set the place in the xml list based on the random questions array
            xmlLoader.setSpeechNum(questionsArray[thisQuestion]);
            super.updatePage();
            domCounter.node.innerHTML = (thisQuestion + 1) + " / " + quizLength;
            this.sizeImage();
            this.setupAnswers();
            //we do not want to use the forward/back buttons
            this.overlayGraphics.getNext().setVisible(false);
            this.overlayGraphics.getBack().setVisible(false);
        }



        closeGuide() {
            //Setup the guide button that resets the speech bubbles
            let navigate = this.scene.get('navigate');

            navigate.setupLocation({
                obj: guide.getGuide(),
                callback: _this.showSpeech
            });

            guide.animateBubbleOut();
        }
        createCounter() {

            domCounter = this.add.dom(0, 0).createFromHTML('');
            let textStyle = domCounter.node.style;

            textStyle.fontSize = 24 * gameScale + 'px';
            textStyle.color = '#ffffff';
            textStyle.width = this.sys.canvas.width;
            textStyle.textAlign = 'center';
            domCounter.x = this.sys.canvas.width / 2 //
            domCounter.y = 543 * gameScale;
            domCounter.setOrigin(0.5);

            domCounter.updateSize();

        }

        guideSettings() {
            return ({
                id: 'guideProfile',
                callback: this.showSpeech,
                x: -35 * gameScale
            });

        }

        sizeImage() {
            let img = this.overlayGraphics.getImage();

            do {
                img.scale -= 0.05;
            } while (img.displayWidth > imgBoundWidth || img.displayHeight > imgBoundHeight)

            img.setOrigin(0.5);

            //the image needs to fit within the boundaries of an imaginary rectangle with the x,y in the center
            img.x = imgBoundX;
            img.y = imgBoundY;

            this.animateImage();
        }
        animateImage() {
            let img = this.overlayGraphics.getImage();

            let scaleIt = -1 * img.scale * 0.2;
            gsap.from(img, {
                ease: 'back',
                duration: 0.5,
                scale: scaleIt
            });
        }
    }